export const NodesIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        d="M13.022,4.914a2.491,2.491,0,1,0-3.063-2.5L4.239,4.7a2.488,2.488,0,1,0-.688,4.024l4.532,3.965a2.491,2.491,0,1,0,4.865.753,2.479,2.479,0,0,0-1.1-2.067l1.176-6.464ZM4.865,7.227a2.438,2.438,0,0,0,.115-.675L10.7,4.264a2.536,2.536,0,0,0,.361.3L9.885,11.021a2.42,2.42,0,0,0-.492.171Z"
        transform="translate(3 2)"
      />
    </svg>
  );
};
